import AirtableTable from "../AirtableTable";
import { Calendar } from "../models";
import { airtableFormulas } from "../formulas";

export class CalendarTable extends AirtableTable<Calendar> {
  constructor(instance: any) {
    super(instance, "Calendar");
    this.returnFieldsByFieldId = false;

    this.fields = [
      "Name",
      "Image",
      "Date",
      "End Date/Time",
      "Description",
      "URL"
    ]
  }

  getUpcomings = () => {
    return this.list({
      filterByFormula: airtableFormulas.calendar.upcoming
    })
  }
}
